<template>
  <div class="sm:px-10 md:px-32 lg:px-64 my-10 bg-gray-500 py-10">
    <BackButton @back="back('submit-request')" />
    <v-card>
      <v-card-title primary-title> Change payment terms </v-card-title>
      <v-card-text>
        <VButtons @onPress="onPress" :items="items" />
      </v-card-text>
    </v-card>

    <!-- component for axios submit -->
    <AlertDialog
      :props_data="props_data"
      :showAlert="showAlert"
      @alertDialogSubmit="alertDialogSubmit"
    />
    <div class="my-2 w-full">
      <v-btn class="w-full" color="blue" @click="submitTicket">
        Submit Request</v-btn
      >
    </div>
    <!-- ================== -->
  </div>
</template>

<script>
import VButtons from "../../common/VButtons.vue";
import AlertDialog from "../../common/AlertDialog.vue";
import BackButton from "../../common/BackButton.vue";
export default {
  data() {
    return {
      props_data: {},
      penalties_to_waive: "",
      showAlert: false,
      items: [
        {
          title: "Same financing scheme",
          route: "same-financing-scheme",
        },
        {
          title: "Full payment/Pre-terminate",
          route: "full-payment",
        },
        {
          title: "Bank to in-house financing",
          route: "bank-in-house-financing",
        },
      ],
    };
  },
  components: {
    AlertDialog,
    BackButton,
    VButtons,
  },
  methods: {
    onPress(e) {
      this.$router.push({ name: e.route });
    },
    back(n) {
      this.$router.push({ name: n });
    },
    submitTicket() {
      this.showAlert = true;
      this.props_data = {
        status_id: 1,
        remarks_id: 1,
        classification_id: this.$route.meta.classification_id,
        request_type_id: this.$route.meta.request_type_id,
        department_id: 10,
        subject: this.$route.meta.subject,
      };
    },
    alertDialogSubmit(name) {
      this.showAlert = false;
      !this.$route.path.includes(name) ? this.$router.push(name) : null;
    },
  },
};
</script>
